<template>
	<div>
		<Carousel :autoplay="true" :autoplay-speed="4000" v-model="value2" loop>
				<CarouselItem>
					<img src="static/image/mainimg/first.jpg" width="100%"/>
				</CarouselItem>
				<CarouselItem>
					<img src="static/image/mainimg/two.jpg" width="100%"/>
				</CarouselItem>
				<CarouselItem>
					<img src="static/image/mainimg/three.jpg" width="100%"/>
				</CarouselItem>
				<CarouselItem>
					<img src="static/image/mainimg/four.jpg" width="100%"/>
				</CarouselItem>
		</Carousel>
	</div>
</template>

<script type="text/ecmascript-6">
	import { Carousel, CarouselItem } from 'iview'

	export default {
		data() {
			return {
				value2: 0,
				imageShow: true
			}
		},
		components: {
			Carousel,
			CarouselItem
		}
	}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"

	.demo-carousel
		width: 100%
</style>



// WEBPACK FOOTER //
// src/components/circle-img/circle-img.vue